import { MdCheckCircle, MdLockOutline, MdRadioButtonUnchecked } from "react-icons/md";
import { Card, ErrorBlock } from "../Primitives";
import { SkeletonPanel } from "../Skeletons";

/*
  O que a conta usa do que tem.

  Três estados, porque a conversa muda: usa (nada a fazer), tem e não usa (treinamento,
  e é onde mora o risco de cancelar por "não vejo valor") e não tem no plano (upgrade).
*/

const PLAN_LABELS = { ESSENTIAL: "Essential", PRO: "PRO", DIAMOND: "Diamond" };

const stateOf = (feature) => {
  if (feature.used) return "USED";
  return feature.available ? "UNUSED" : "LOCKED";
};

const STATE = {
  USED: {
    Icon: MdCheckCircle,
    className: "text-emerald-600",
    hint: () => "usa",
  },
  UNUSED: {
    Icon: MdRadioButtonUnchecked,
    className: "text-amber-500",
    hint: () => "tem e não usa",
  },
  LOCKED: {
    Icon: MdLockOutline,
    className: "text-slate-300",
    hint: (feature) => `a partir do ${PLAN_LABELS[feature.minPlan] || feature.minPlan}`,
  },
};

const AdoptionPanel = ({ insights }) => {
  if (insights.isLoading) return <SkeletonPanel lines={8} />;

  if (insights.error) {
    return (
      <ErrorBlock
        message="Não foi possível carregar o mapa de adoção."
        onRetry={insights.refetch}
      />
    );
  }

  const adoption = insights.data?.adoption;
  if (!adoption) return null;

  return (
    <Card className="overflow-hidden">
      <div className="border-b border-slate-100 px-4 py-3">
        <h2 className="text-sm font-bold text-slate-900">Mapa de adoção</h2>
        <p className="text-[11px] text-slate-500">
          Usa {adoption.usedCount} recurso(s)
          {adoption.unusedPaidCount > 0
            ? ` · ${adoption.unusedPaidCount} já incluso(s) no plano sem uso`
            : ""}
        </p>
      </div>

      <ul className="grid grid-cols-1 gap-x-4 px-4 py-2 sm:grid-cols-2">
        {adoption.features.map((feature) => {
          const state = STATE[stateOf(feature)];
          const { Icon } = state;

          return (
            <li
              key={feature.id}
              className="flex items-center justify-between gap-2 py-1.5"
            >
              <span className="flex min-w-0 items-center gap-2 text-sm text-slate-800">
                <Icon size={16} className={`shrink-0 ${state.className}`} />
                <span className="truncate">{feature.label}</span>
              </span>
              <span className="shrink-0 text-[11px] text-slate-500">
                {state.hint(feature)}
              </span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default AdoptionPanel;
